// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris


interface AuthFailureLike {
  errorCode?: unknown;
  subError?: unknown;
  errorMessage?: unknown;
  message?: unknown;
  status?: unknown;
}

function readAadstsCode(message: string): string | undefined {
  const match = /AADSTS\d+/.exec(message);
  return match?.[0];
}

function asText(value: unknown): string {
  return typeof value === "string" ? value : "";
}

export function describeAuthFailure(error: unknown): string {
  if (error === null || error === undefined) {
    return "unknown-failure";
  }

  const failure = error as AuthFailureLike;
  const code = asText(failure.errorCode);
  const subError = asText(failure.subError);
  const aadsts = readAadstsCode(
    asText(failure.errorMessage) || asText(failure.message),
  );

  const parts: string[] = [];
  if (code.length > 0) {
    parts.push(`code=${code}`);
  }
  if (subError.length > 0) {
    parts.push(`subError=${subError}`);
  }
  if (aadsts !== undefined) {
    parts.push(`aadsts=${aadsts}`);
  }
  if (typeof failure.status === "number") {
    parts.push(`status=${failure.status}`);
  }

  return parts.length > 0 ? parts.join(" ") : "unknown-failure";
}

export function logAuthFailure(context: string, error: unknown): void {
  console.error(`[auth] ${context}: ${describeAuthFailure(error)}`);
}